<!-- 小程序管理-投手版 -->
<template>
  <div>
    <div id="" :style="{ width: table_scroll_width + 'px' }">
      <div
        :style="{ width: body_width + 'px' }"
        style="position: sticky; left: 30px; z-index: 5"
      >
        <!-- 标题 -->
        <div class="page-title">引导小程序：投手版</div>

        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: 10px 0 0;
          "
        >
          <div class="screen-box">
            <div class="screen-label">小程序名称</div>
            <a-input
              v-model="r_applets_name"
              allowClear
              placeholder="请输入公众号名称"
              style="width: 200px"
            />
          </div>

          <div class="screen-box">
            <div class="screen-label">状态</div>
            <a-select
              style="min-width: 200px"
              placeholder="请选择状态"
              @change="handleChangeA"
              :filter-option="filterOption"
              :getPopupContainer="getsPopupContainer"
              allowClear
              showSearch
            >
              <a-select-option value="1"> 开启 </a-select-option>
              <a-select-option value="0"> 关闭 </a-select-option>
            </a-select>
          </div>

          <a-button
            @click="searchButton('button')"
            :loading="search_button_loading"
            type="primary"
            icon="search"
            class="screen-box"
            >搜索</a-button
          >

          <a-button class="screen-box" @click="setAdmin" type="primary"
            >批量设置管理员（ {{ selectedData.length }} ）</a-button
          >

          <a-button
            @click="addXCX"
            style="background-color: #67c23a; border-color: #67c23a"
            type="primary"
            class="screen-box"
            >添加小程序</a-button
          >
        </div>
      </div>
    </div>

    <div>
      <!-- 表头 -->
      <div class="table-th" :style="{ width: table_scroll_width + 'px' }">
        <div
          class="table-th-cell-sticky"
          style="display: flex; align-items: center"
        >
          <div class="table-th-cell" :style="{ width: 45 + 'px' }">
            <a-checkbox
              :indeterminate="indeterminate"
              :checked="checkAll"
              @change="onCheckAllChange"
            ></a-checkbox>
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[0].width + 'px' }"
          >
            ID
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[1].width + 'px' }"
          >
            小程序名称
          </div>
          <div
            class="table-th-cell"
            :style="{ width: rableTitle[2].width + 'px' }"
          >
            操作
          </div>
        </div>
        <div v-for="(item, index) in rableTitle" :key="index">
          <div
            class="table-th-cell"
            v-if="index > 2"
            :style="{ width: item.width + 'px' }"
          >
            {{ item.title }}
          </div>
        </div>
      </div>

      <!-- 表格内容 -->
      <div
        v-for="(item, index) in tableShowData"
        :key="index"
        class="table-td"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <div
          class="table-td-cell-sticky"
          style="display: flex; align-items: center"
          :style="{ height: item.height + 'px' }"
        >
          <!-- 选择 -->
          <div class="table-td-cell" :style="{ width: 45 + 'px' }">
            <a-checkbox
              :checked="item.checked"
              @change="onChangeCheckbox($event, index)"
            ></a-checkbox>
          </div>
          <!-- ID -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[0].width + 'px' }"
          >
            {{ item.id }}
          </div>
          <!-- 小程序名称 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[1].width + 'px' }"
          >
            {{ item.name }}
          </div>
          <!-- 操作 -->
          <div
            class="table-td-cell"
            :style="{ width: rableTitle[2].width + 'px' }"
            style="display: flex; flex-wrap: wrap"
          >
            <div @click="tdCz(1, item)" class="cz-cell">编辑</div>
            <div @click="tdCz(2, item)" class="cz-cell">清空监控计数</div>
            <div @click="tdCz(4, item)" class="cz-cell">重新生成小程序码</div>
          </div>
        </div>
        <!-- 原始ID -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[3].width + 'px' }"
        >
          {{ item.app_origin_id }}
        </div>
        <!-- APPID -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[4].width + 'px' }"
        >
          {{ item.app_id }}
        </div>
        <!-- 密钥 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[5].width + 'px' }"
        >
          {{ item.app_secret }}
        </div>
        <!-- 小程序类型 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[6].width + 'px' }"
        >
          {{ contentTypeMap[item.content_type] || "" }}
        </div>

        <!-- 跳转路径 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[7].width + 'px' }"
        >
          {{ item.app_path }}
        </div>
        <!-- 状态 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[8].width + 'px' }"
          style="color: #62a8ea; cursor: pointer"
        >
          <a-switch
            @change="statusChange($event, item)"
            :checked="item.status_checked"
            :loading="item.status_loading"
            size="small"
            checked-children="开启"
            un-checked-children="关闭"
          />
        </div>
        <!-- 引导页所在公众号 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[9].width + 'px' }"
        >
          {{ item.gzh_account }}
        </div>
        <!-- 监控计数 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[10].width + 'px' }"
        >
          {{ item.count_appplets }}
        </div>

        <!-- 上线天数 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[11].width + 'px' }"
        >
          {{ item.day }}
        </div>

        <div
          class="table-td-cell"
          :style="{ width: rableTitle[12].width + 'px' }"
        >
          {{ item.scheme_count }}
        </div>
        <!-- 跳转码当天使用量 -->
        <div
          class="table-td-cell"
          :style="{ width: rableTitle[13].width + 'px' }"
        >
          {{ item.use_count }}
        </div>
      </div>
      <div
        style="
          position: fixed;
          right: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 90vh;
          width: 30px;
        "
      ></div>
      <div
        style="
          position: fixed;
          left: 0;
          bottom: 0;
          z-index: 6;
          background-color: #fff;
          height: 90vh;
          width: 30px;
        "
      ></div>

      <div
        v-show="tableShowData.length === 0"
        style="text-align: center; text-align: center; padding: 80px 0 50px"
        :style="{ width: table_scroll_width + 'px' }"
      >
        <a-icon style="font-size: 70px; color: #999" type="file-search" />

        <div style="color: #999; font-size: 16px; margin-top: 20px">
          内容为空
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div :style="{ width: table_scroll_width + 'px' }">
      <div
        style="
          text-align: center;
          margin-top: 30px;
          position: sticky;
          left: 30px;
        "
        :style="{ width: body_width - 30 + 'px' }"
      >
        <a-pagination
          v-model="r_page"
          :pageSize="20"
          :total="table_total"
          @change="paginationChange"
          hideOnSinglePage
        />
      </div>
    </div>

    <!-- 编辑单项的弹窗 -->
    <a-modal
      :title="`${edit_modal_title}`"
      :visible="edit_visible"
      :confirm-loading="confirmLoading"
      cancelText="取消"
      okText="确认"
      width="600px"
      @ok="editModalOk"
      @cancel="editModalCancel"
    >
      <div v-if="edit_modal_title.indexOf('批量操作') > -1">
        <a-radio-group
          @change="xcxRadioB"
          name="radioGroup"
          :value="x_is_using"
        >
          <a-radio value="1"> 开启 </a-radio>
          <a-radio value="0"> 关闭 </a-radio>
        </a-radio-group>
      </div>

      <div v-else-if="edit_modal_title.indexOf('批量替换') > -1">
        <div class="form-cell-box">
          <div class="class-title">小程序替换为</div>
          <a-select
            show-search
            style="min-width: 360px"
            placeholder="请选择小程序"
            @change="editChangeA"
            :value="e_applets_id"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            showSearch
          >
            <a-select-option
              v-for="(item, index) in selectXcx"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div style="color: red; margin-left: 125px">
          <div>提示</div>
          <div>1.请确认新小程序与被替换的小程序，关联了同一个公众号。</div>
          <div>2.替换后，公众号的跳转配置会自动开启。</div>
        </div>
      </div>
    </a-modal>

    <!-- 批量设置管理员 -->
    <a-modal
      :visible="pl_modal"
      title="批量设置管理员"
      okType="primary"
      width="700px"
      okText="设置"
      cancelText="取消"
      @ok="plOk"
      @cancel="plCancel"
      :confirmLoading="pl_loading"
    >
      <div style="">
        <div style="display: flex; align-items: center">
          <div style="margin-right: 15px; font-size: 15px">
            请选择要添加的管理员
          </div>
          <a-select
            style="min-width: 200px"
            placeholder="请选择管理员"
            @change="handleChangeD"
            :labelInValue="true"
            :value="s_admin_id"
            :filter-option="filterOption"
            :getPopupContainer="getsPopupContainer"
            allowClear
          >
            <a-select-option
              v-for="(item, index) in filterData.op_id.list"
              :key="item.key"
              :value="item.key"
            >
              {{ item.value }}
            </a-select-option>
          </a-select>
        </div>
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            margin: 15px 0 30px;
            max-height: 100px;
            overflow-y: auto;
          "
        >
          <div
            style="
              width: 150px;
              display: flex;
              align-items: center;
              margin-bottom: 5px;
            "
            v-for="(item, index) in pl_select_admin"
            :key="index"
          >
            <div style="margin-right: 15px">{{ item.label }}</div>
            <!-- <div @click="delSelectAdmin(index)" style="color: red;cursor: pointer;">删除</div> -->
            <a-icon @click="delSelectAdmin(index)" type="close-circle" />
          </div>
        </div>
        <div style="margin-bottom: 10px; margin-top: 15px">
          已选的小程序名称：
        </div>
        <div
          style="
            max-height: 360px;
            overflow-y: auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: default;
          "
        >
          <div
            v-for="(item, index) in selectedData"
            :key="index"
            style="
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              margin-right: 10px;
            "
            class=""
          >
            <div style="width: 70px; text-align: right">id：{{ item.id }}</div>
            <span style="margin: 0 5px"> — </span>
            <div style="width: 170px">{{ item.name }}</div>
          </div>
        </div>

        <!-- <div class="">id：4 —— 李永润</div> -->
      </div>
    </a-modal>

    <!-- 设置小程序侧边栏 -->
    <a-drawer
      title="设置小程序"
      width="600px"
      placement="right"
      :closable="false"
      :visible="set_visible"
      @close="setCloseDrawer"
    >
      <div>
        <div
          v-for="(item, index) in setShowData"
          :key="index"
          class="set-xcx-box"
        >
          <!-- <div class="set-xcx-box"> -->

          <div class="form-cell-box">
            <div class="class-title" style="width: 130px">
              小程序跳转文章链接<span class="required-hint">*</span>
            </div>

            <a-input
              v-model="item.j_url"
              placeholder="请输入"
              style="width: 300px"
            />
          </div>

          <a-icon
            @click="setDel(index)"
            style="
              position: absolute;
              right: 7px;
              top: 7px;
              font-size: 20px;
              cursor: pointer;
            "
            type="close-circle"
          />
        </div>

        <div
          style="
            color: red;
            height: 23px;
            width: 100%;
            margin-top: -15px;
            margin-bottom: 10px;
          "
        >
          {{ set_form_hint }}
        </div>

        <a-button
          @click="setAddXcx"
          style="background-color: #67c23a; border-color: #67c23a"
          type="primary"
          >新增文章链接</a-button
        >
      </div>

      <div class="form-cell-box" style="margin-top: 25px; margin-bottom: 50px">
        <a-button
          @click="setRequest"
          :loading="set_button_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="setCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 添加/编辑小程序侧边栏 xcx_visible -->
    <a-drawer
      :title="`${xcx_drawer_title}引导小程序`"
      width="650px"
      placement="right"
      :closable="false"
      :visible="xcx_visible"
      @close="xcxCloseDrawer"
    >
      <!--  小程序名称-->
      <div class="form-cell-box">
        <div class="class-title">
          小程序名称<span class="required-hint">*</span>
        </div>
        <a-input
          v-model="x_name"
          allowClear
          placeholder="请输入小程序名称"
          style="width: 300px"
        />
      </div>
      <!-- 小程序原始ID -->
      <div class="form-cell-box">
        <div class="class-title">
          小程序原始ID<span class="required-hint">*</span>
        </div>
        <a-input
          v-model="x_app_origin_id"
          allowClear
          placeholder="请输入小程序原始ID"
          style="width: 300px"
        />
      </div>
      <!-- 小程序APPID -->
      <div class="form-cell-box">
        <div class="class-title">
          小程序APPID<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="x_app_id"
          allowClear
          placeholder="请输入小程序APPID"
          style="width: 300px"
        />
      </div>
      <!-- 小程序密钥 -->
      <div class="form-cell-box">
        <div class="class-title">
          小程序密钥<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="x_app_secret"
          allowClear
          placeholder="请输入小程序密钥"
          style="width: 300px"
        />
      </div>

      <!-- 小程序类型 -->
      <div class="form-cell-box">
        <div class="class-title">
          小程序类型<span class="required-hint">*</span>
        </div>
        <a-select
          style="min-width: 200px"
          placeholder="请选择小程序类型"
          @change="handleChangeC"
          :filter-option="filterOption"
          :getPopupContainer="getsPopupContainer"
          :value="x_content_type"
          showSearch
        >
          <a-select-option :value="1"> 排行榜 </a-select-option>
          <a-select-option :value="2">
            天天书币领不停（微博专用）
          </a-select-option>
          <!-- <a-select-option :value="3"> 金币天天领小程序 </a-select-option> -->
        </a-select>
      </div>
      <!-- 跳转路径 -->
      <div class="form-cell-box">
        <div class="class-title">
          跳转路径<span class="required-hint">*</span>
        </div>

        <a-input
          v-model="x_app_path"
          allowClear
          placeholder="请输入跳转路径"
          style="width: 300px"
        />
      </div>
      <!-- 引导页所在公众号（需要关联小程序） -->
      <div class="form-cell-box">
        <div class="class-title">
          引导页所在公众号（需要关联小程序）<span class="required-hint">*</span>
        </div>
        <a-input
          v-model="x_gzh_account"
          allowClear
          placeholder="请输入引导页所在公众号"
          style="width: 300px"
        />
      </div>
      <div class="form-cell-box">
        <div class="class-title">是否启用</div>

        <a-switch
          @change="xcxDrawerSwitch"
          :checked="xx_status"
          checked-children="启用"
          un-checked-children="暂停"
        />
      </div>

      <div class="form-cell-box" style="margin-top: 30px; padding-left: 41px">
        <a-button
          @click="xcxRequest"
          :loading="xcx_add_edit_loading"
          type="primary"
          style="margin-right: 20px"
          >确认</a-button
        >
        <a-button @click="xcxCloseDrawer">取消</a-button>
      </div>
    </a-drawer>

    <!-- 加载中 -->
    <div class="loading-box" v-show="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import {
  xcxOperList,
  putDataMenu,
  putGzhSetWechatid,
  opeGzhSelect,
  opeGzhXcx,
  xcxOperSetUser,
  xcxOperBatchGzh,
  xcxOperReplaceGzh,
  opeGzhClearMessage,
  xcxOperClearXcxScheme,
  opeGzhGetApplets,
  xcxOperAddJumpUrl,
  xcxOperSetStatus,
  xcxOperAddXcx,
  xcxOperEditXcx,
  xcxOperClearCount,
  xcxOperGetJumpUrl,
} from "@/request/api";
export default {
  name: "xcxPut_",
  components: {},
  data() {
    return {
      contentTypeMap: {
        1: `排行榜`,
        2: `天天书币领不停（微博专用）`,
      },
      // 表格部分内容
      // 表格的表头，规定宽度和要用的其他信息
      rableTitle: [
        { title: "ID", width: 60, type: "id" }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
        { title: "小程序名称", width: 100, type: "name" },
        { title: "操作", width: 135, type: "cz" },
        { title: "原始ID", width: 145, type: "app_origin_id" },
        { title: "APPID", width: 180, type: "app_id" },
        { title: "密钥", width: 160, type: "app_secret" },
        { title: "小程序类型", width: 150, type: "content_type_name" },
        { title: "跳转路径", width: 160, type: "app_path" },
        { title: "状态", width: 100, type: "status" },
        {
          title: "引导页所在公众号（需要关联小程序）",
          width: 140,
          type: "gzh_account",
        },
        { title: "监控计数", width: 100, type: "count_appplets" },
        { title: "上线天数", width: 100, type: "day" },
        { title: "跳转码当天生成数", width: 150, type: "scheme_count" },
        { title: "跳转码当天使用量", width: 150, type: "use_count" },
      ],
      tableShowData: [],
      body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
      table_scroll_width: 1000,
      search_button_loading: false,

      r_page: 1,
      r_pageSize: 20,
      table_total: 0,

      r_applets_name: "", // 小程序名称
      r_status: "", // 1表示开启，0表示关闭

      // 多选
      indeterminate: false,
      checkAll: false,
      selectedData: [], // 选择内容存放数组

      // 筛选条件部分
      filterData: {
        op_id: {
          list: [{}],
        },

        media_id: {
          list: [{}],
        },
        channel_id: {
          list: [{}],
        },
        gzh_id: {
          list: [{}],
        },
      }, // 筛选条件数组

      // 单个编辑弹窗
      edit_visible: false, // 编辑弹窗的显示
      edit_modal_title: "", // 编辑弹窗的标题
      confirmLoading: false,
      e_jump_url: "", // 编辑公众号关注页链接请求需要的参数
      e_wechatid: "", // 编辑微信ID请求需要的参数
      e_id: "", // 编辑请求用的id
      e_channel_id: undefined, // 渠道编辑
      e_applets_id: undefined, // 替换小程序

      // 批量设置管理员
      pl_modal: false,
      pl_loading: false,
      pl_select_admin: [],
      s_admin_id: undefined, // 设置管理员的管理员id

      searchSelect: [{}],
      selectXcx: [],

      // 设置小程序
      set_visible: false,
      set_form_hint: "", // 设置小程序侧边栏的提示
      set_button_loading: false,
      setShowData: [], // 展示内容的数据
      set_applets_id: "", // 要设置的小程序请求用的id

      xcx_visible: false,
      xcx_add_edit_loading: false,
      xcx_drawer_title: "新增", // 侧边栏标题

      x_gzh_account: "", // 引导页所在公众号（需要关联小程序）
      x_name: "", // 小程序名称
      x_app_id: "", // 小程序APPID
      x_app_secret: "", // 小程序密钥
      x_app_path: "", // 跳转路径
      x_jump_type: 1, // 跳转方式
      xx_status: false, // 是否启用
      x_id: "", // 编辑用的id
      x_content_type: undefined, // 小程序类型
      x_app_origin_id: "", // 小程序原始ID

      x_is_using: "1", // 批量操作公众号。1为开启，0为关闭

      aaa: "",
    };
  },
  mounted() {
    let that = this;

    that.search_button_loading = true;

    that.body_width = document.body.clientWidth - 60 - 50; // 筛选条件大盒子的宽度
    let nn = 0;
    that.rableTitle.forEach((res, index) => {
      nn = nn + res.width;
    });
    that.table_scroll_width = nn + 30 + 60;

    // 接收从小程序跳转码页面传过来的参数
    console.log(this.$route.query);
    if (this.$route.query) {
      if (this.$route.query.gzh_name) {
        // this.r_gzh_name = this.$route.query.gzh_name
      }
    }

    putDataMenu().then((res) => {
      console.log("获取搜索条件", res);
      that.filterData = res.data.data.filter;
    });

    opeGzhSelect().then((res) => {
      console.log("获取渠道、管理员选择", res);
      that.searchSelect = res.data.data;
    });

    opeGzhXcx().then((res) => {
      console.log("获取小程序", res);
      that.selectXcx = res.data.data.applets;
    });

    that.searchButton();
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 状态选择
    handleChangeA(e) {
      console.log("状态", e);
      this.r_status = e;
    },
    // 编辑-小程序类型
    handleChangeC(e) {
      this.x_content_type = e;
    },
    // 批量设置管理员，选择管理员
    handleChangeD(e) {
      console.log(e);
      this.s_admin_id = e;
      let ttt = true;
      this.pl_select_admin.forEach((res) => {
        if (res.key == e.key) {
          ttt = false;
        }
      });
      if (ttt) {
        this.pl_select_admin.push(e);
      }
    },
    // 编辑渠道
    handleChangeE(e) {
      console.log(e);
      this.e_channel_id = e;
    },
    // 删除选择的管理员
    delSelectAdmin(index) {
      this.pl_select_admin.splice(index, 1);
    },
    // 搜索
    searchButton(type) {
      let that = this;
      that.search_button_loading = true;

      if (type != "分页") {
        // 除开分页以外的请求都要把选中状态清空
        that.selectedData = []; // 已选内容清空
        that.r_page = 1;
      }

      xcxOperList({
        page: that.r_page,
        pageSize: that.r_pageSize,
        applets_name: that.r_applets_name, // 小程序名称
        status: that.r_status, // 状态
        type: 1,
      }).then((res) => {
        console.log("搜索结果", res);
        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          let data = res.data.data.data;
          data.forEach((res) => {
            res.checked = false; // 用于多选和单选
            res.status_checked = false;
            res.status_loading = false; // 变更状态的加载中状态
            if (res.status == 1) {
              // 1=开启 0=关闭
              res.status_checked = true;
            }
          });

          if (that.selectedData.length > 0) {
            let ccc = true;
            let iii = 0; // 用于判断是否全选
            data.forEach((res) => {
              that.selectedData.forEach((res_r) => {
                if (res.id === res_r.id) {
                  res.checked = true;
                  ccc = false;
                  iii = iii + 1;
                }
              });
            });
            console.log("iii", iii);
            if (iii === 20) {
              // 全选
              that.indeterminate = false;
              that.checkAll = true;
            } else {
              if (ccc) {
                that.checkAll = false;
                that.indeterminate = false;
              } else {
                that.checkAll = false;
                that.indeterminate = true;
              }
            }
          } else {
            console.log("that.checkAll", that.checkAll);
            that.checkAll = false;
            that.indeterminate = false;
          }

          that.search_button_loading = false;
          that.table_total = res.data.data.total;
          console.log("data", data);
          that.tableShowData = data;
        } else {
          that.search_button_loading = false;
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }

        // 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
        document
          .querySelector("body")
          .setAttribute("style", "overflow-x: visible;");
        setTimeout(() => {
          document
            .querySelector("body")
            .setAttribute("style", "overflow-x: visible;");
        }, 300);
      });
    },
    // 分页
    paginationChange(e) {
      this.r_page = e;
      this.searchButton("分页");
    },
    // 巨量链接复制
    mkUrlCopy(e) {
      console.log(e);
      let that = this;
      this.$copyText(e.mk_click_url)
        .then((res) => {
          that.$message.success("复制成功");
        })
        .catch((err) => {
          that.$message.error("复制失败");
        });
    },
    // 批量设置管理员
    setAdmin() {
      if (this.selectedData.length > 0) {
        this.pl_modal = true;
      } else {
        this.$message.warning("请先选择内容");
      }
    },
    // 全选
    onCheckAllChange(e) {
      let that = this;
      if (that.checkAll) {
        that.tableShowData.forEach((res) => {
          res.checked = false;
        });
        that.checkAll = false;

        that.selectedData = []; // 取消全选的时候，全部清除
      } else {
        that.tableShowData.forEach((res) => {
          res.checked = true;
          // 有重复的就不要传了
          let ddd = true;
          that.selectedData.forEach((res_r) => {
            if (res_r.id === res.id) {
              ddd = false;
              console.log("l", ddd);
            }
          });

          if (ddd) {
            console.log("w", ddd);
            that.selectedData.push(res);
          }
        });

        that.indeterminate = false;
        that.checkAll = true;
      }
    },
    // 单选
    onChangeCheckbox(checkedList, index) {
      let that = this;
      if (that.tableShowData[index].checked) {
        // 为选中状态，然后要改为未选中状态
        that.tableShowData[index].checked = false;

        let iii;
        console.log(
          "that.tableShowData[index].id",
          that.tableShowData[index].id
        );
        that.selectedData.forEach((res, index_z) => {
          if (res.id == that.tableShowData[index].id) {
            iii = index_z;
          }
        });
        that.selectedData.splice(iii, 1);
        console.log("iii", iii);
      } else {
        // 未选中状态改为选中状态
        that.tableShowData[index].checked = true;
        if (that.selectedData.length === 0) {
          that.selectedData.push(that.tableShowData[index]);
        } else {
          // 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
          let ddd = true;
          for (let i = 0; i < that.selectedData.length; i++) {
            if (that.selectedData[i].id === that.tableShowData[index].id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            that.selectedData.push(that.tableShowData[index]);
          }
        }
      }
      // that.tableShowData[index].checked = !that.tableShowData[index].checked
      console.log("that.selectedData", that.selectedData);
      let ccc = true;
      let iii = false;
      let nnn = that.selectedData.length || 0;
      console.log("that.selectedData.length", that.selectedData.length);
      that.tableShowData.forEach((res) => {
        if (res.checked) {
          iii = true;
          // nnn = nnn + 1
        }
        if (!res.checked) {
          ccc = false;
        }
      });
      // console.log("nnn",nnn)
      if (ccc) {
        that.indeterminate = false;
      } else {
        that.indeterminate = iii;
      }
      that.checkAll = ccc;
    },

    // 编辑弹窗确认按钮
    editModalOk() {
      let that = this;

      if (that.edit_modal_title.indexOf("批量操作") > -1) {
        that.confirmLoading = true;
        xcxOperBatchGzh({
          id: that.e_id,
          is_using: that.x_is_using,
        })
          .then((res) => {
            that.confirmLoading = false;
            console.log("批量操作公众号", res);
            that.editModalCancel();
            that.$message.success("操作成功");
            that.searchButton();
          })
          .catch((err) => {
            that.confirmLoading = false;
          });
      } else if (that.edit_modal_title.indexOf("批量替换") > -1) {
        if (that.e_applets_id) {
          that.confirmLoading = true;
          xcxOperReplaceGzh({
            replace_id: that.e_id, // 选择的表格内的id
            applets_id: that.e_applets_id, // 下拉框选择的小程序id
          })
            .then((res) => {
              that.confirmLoading = false;
              console.log("批量替换", res);
              that.editModalCancel();
              that.$message.success("操作成功");
              that.searchButton();
            })
            .catch((err) => {
              that.confirmLoading = false;
            });
        } else {
          that.$message.warning("请先选择小程序");
        }
      }
    },
    // 编辑弹窗取消
    editModalCancel() {
      if (this.confirmLoading) {
        return;
      }
      this.e_applets_id = undefined;
      this.edit_visible = false;
    },
    // 批量设置投放人员弹窗确认按钮
    plOk() {
      let that = this;
      // if(that.pl_select_admin.length > 0){ // 得选择投放人员
      that.pl_loading = true;
      let a_data = [];
      that.pl_select_admin.forEach((res) => {
        a_data.push(res.key);
      });
      console.log("a_data", a_data);

      let i_data = [];
      that.selectedData.forEach((res) => {
        i_data.push(res.id);
      });
      console.log("i_data", i_data);

      xcxOperSetUser({
        admin_id: a_data,
        ids: i_data,
        type: 1, // 这里表示是投手版。小程序管理-投手版
      }).then((res) => {
        that.pl_loading = false;
        console.log("批量设置投放人员", res);
        that.selectedData = [];
        that.plCancel();
        that.$message.success("设置成功");
        that.searchButton();
      });
      // }
      // else {
      // 	this.$message.warning('请先选择管理员');
      // }
    },
    // 批量设置管理员弹窗取消按钮
    plCancel() {
      if (this.pl_loading) {
        return;
      }
      this.pl_select_admin = [];
      this.pl_modal = false;

      this.selectedData = [];
      // 这里清空状态是为了避免批量设置和单个设置的状态混淆
      this.tableShowData.forEach((res) => {
        res.checked = false;
      });
      this.checkAll = false;
      this.indeterminate = false;

      this.s_admin_id = undefined;
    },
    // 表格-管理员项的编辑
    setAdminShow(e) {
      console.log(e);
      let that = this;
      this.selectedData = [];
      // 这里清空状态是为了避免批量设置和单个设置的状态混淆
      this.tableShowData.forEach((res) => {
        res.checked = false;
      });
      this.checkAll = false;
      this.indeterminate = false;
      this.selectedData.push(e);
      // console.log(e.admin_id);
      // 如果要恢复这里，记得给select组件设置labelInValue为true
      e.user.forEach((res) => {
        let obj = {
          label: res.admin_name,
          key: res.admin_id,
        };
        this.pl_select_admin.push(obj);
      });
      // this.s_admin_id = e.admin_id
      this.pl_modal = true;
    },
    // 状态切换
    statusChange(e, item) {
      let that = this;
      console.log("状态切换", e, item);
      item.status_loading = true;
      xcxOperSetStatus({
        id: item.id,
      }).then((res) => {
        console.log("状态切换", res);
        item.status_loading = false;

        if (
          res.data.code === 0 ||
          res.data.code === 200 ||
          res.data.code == 8011
        ) {
          item.status_checked = e;
          if (e) {
            // 这里的状态也要更新。1=开启 0=关闭
            item.status = 1;
          } else {
            item.status = 0;
          }
          that.$message.success("操作成功");
        } else {
          if (res.data.code === 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },

    // 表格里的操作
    tdCz(e, item) {
      console.log("item", item);
      let that = this;
      if (e == 1) {
        // 编辑
        that.x_id = item.id;
        (that.x_gzh_account = item.gzh_account), // 引导页所在公众号（需要关联小程序）
          (that.x_name = item.name), // 小程序名称
          (that.x_app_id = item.app_id), // 小程序APPID
          (that.x_app_secret = item.app_secret), // 小程序密钥
          (that.x_app_path = item.app_path), // 跳转路径
          (that.x_jump_type = item.jump_type); // 跳转方式
        (that.x_content_type = item.content_type || undefined), // 小程序类型
          (that.x_app_origin_id = item.app_origin_id); // 小程序原始ID
        if (item.status == 1) {
          // 开启
          that.xx_status = true;
        } else {
          that.xx_status = false;
        }
        this.xcx_drawer_title = "编辑";
        this.xcx_visible = true;
      } else if (e == 2) {
        // 清空监控计数
        this.$confirm({
          title: "确认要清空监控计数吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          onOk() {
            that.search_button_loading = true;

            xcxOperClearCount({
              id: item.id,
            })
              .then((res) => {
                console.log("清空监控计数", res);
                that.search_button_loading = false;
                if (
                  res.data.code === 0 ||
                  res.data.code === 200 ||
                  res.data.code == 8011
                ) {
                  that.$message.success("操作成功");
                } else {
                  if (res.data.code === 401) {
                    // 未登录
                    localStorage.removeItem("access_token");
                    that.$router.replace({
                      name: "login",
                      params: { type: "not_log" },
                    });
                  } else {
                    that.$message.error(`错误：${res.data.msg}`);
                  }
                }
              })
              .catch((err) => {
                that.search_button_loading = false;
                console.log("err", err);
                that.$message.error("操作失败，请检查请求操作");
              });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 3) {
        // 查看小程序码
        that.$router.push({
          path: "/xcxScheme",
          query: { applets_id: item.id },
        });
      } else if (e == 4) {
        // 重新生成小程序码
        this.$confirm({
          title: "确定重新生成小程序码吗？",
          content: `ID：${item.id}`,
          cancelText: "取消",
          okText: "确认",
          onOk() {
            that.search_button_loading = true;
            xcxOperClearXcxScheme({
              id: item.id,
            })
              .then((res) => {
                console.log("生成小程序码", res);
                that.search_button_loading = false;
                if (
                  res.data.code === 0 ||
                  res.data.code === 200 ||
                  res.data.code == 8011
                ) {
                  that.$message.success(res.data.msg || "操作成功");
                } else {
                  if (res.data.code === 401) {
                    // 未登录
                    localStorage.removeItem("access_token");
                    that.$router.replace({
                      name: "login",
                      params: { type: "not_log" },
                    });
                  } else {
                    that.$message.error(`错误：${res.data.msg}`);
                  }
                }
              })
              .catch((err) => {
                console.log("err", err);
                that.$message.error("操作失败，请检查请求操作");
              });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      } else if (e == 5) {
        // 查看配置公众号

        that.$router.push({ path: "/openGzh", query: { applets_id: item.id } });
      } else if (e == 6) {
        // 批量操作公众号
        that.edit_modal_title = `批量操作『 ${item.name} 』的公众号`;
        that.e_id = item.id;
        that.edit_visible = true;
      } else if (e == 7) {
        // 设置文章链接
        // 获取文章链接
        that.search_button_loading = true;
        xcxOperGetJumpUrl({
          app_id: item.app_id,
        }).then((res) => {
          that.search_button_loading = false;
          console.log("获取文章链接", res.data.data.list);
          let arr = [];
          let data = res.data.data.list;
          let o_data = Object.keys(data);
          o_data.forEach((res) => {
            console.log("res", data[res]);
            let obj = {};
            obj.xcx_name = obj[res];
            obj.j_url = data[res];

            arr.push(obj);
          });
          console.log("arr", arr);
          that.setShowData = arr;
          that.set_applets_id = item.app_id;
          that.set_visible = true;
        });
      } else if (e == 8) {
        //  批量替换小程序
        that.edit_modal_title = `批量替换小程序`;
        that.e_id = item.id;
        that.edit_visible = true;
      }
    },
    // 设置小程序
    setRequest() {
      let that = this;

      console.log("that.setShowData", that.setShowData);
      if (that.setShowData.length > 0) {
        let ccc = true;
        that.setShowData.forEach((res) => {
          if (!res.j_url) {
            ccc = false;
          }
        });
        if (ccc) {
          that.set_button_loading = true;
          that.set_form_hint = "";

          let r_arr = [];
          that.setShowData.forEach((res) => {
            r_arr.push(res.j_url);
          });
          xcxOperAddJumpUrl({
            app_id: that.set_applets_id,
            jump_urls: r_arr,
          })
            .then((res) => {
              that.set_button_loading = false;
              console.log("设置文章链接", res);
              if (
                res.data.code === 0 ||
                res.data.code === 200 ||
                res.data.code == 8011
              ) {
                that.setCloseDrawer();
                that.$message.success("设置成功");
              } else {
                if (res.data.code === 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            })
            .catch((err) => {
              that.set_button_loading = false;
            });
        } else {
          that.set_form_hint = "内容不能为空，请检查是否有遗漏";
        }
      } else {
        this.$message.warning("请先添加文章链接");
      }
    },
    setCloseDrawer() {
      let that = this;
      if (this.set_button_loading) {
        return;
      }
      this.set_visible = false;
      this.set_form_hint = "";
    },
    setChangeA(e, item, index) {
      // 选择小程序
      console.log(e);
      console.log(item);
      console.log(this.setShowData[index]);
      this.selectXcx.forEach((res_k) => {
        if (e === res_k.id) {
          item.xcx_status = res_k.status; // 1表示开启。0表示关闭
        }
      });
      item.applets_id = e;
    },
    setChangeB(e, item) {
      // 是否启用
      console.log(e);
      item.checked = e;
    },
    setChangeC(e) {
      // 序号输入框
      console.log(e);
    },
    // 新增小程序
    setAddXcx() {
      let obj = {
        xcx_name: "",
        j_url: "",
      };

      this.setShowData.push(obj);
    },
    // 删除准备新增的小程序
    setDel(index) {
      this.setShowData.splice(index, 1);
    },

    // 添加小程序
    addXCX() {
      this.xcx_drawer_title = "新增";
      this.xcx_visible = true;
    },
    // 跳转方式
    xcxRadioA(e) {
      this.x_jump_type = e.target.value;
    },
    // 批量操作 开启/关闭
    xcxRadioB(e) {
      this.x_is_using = e.target.value;
    },
    // 是否启用
    xcxDrawerSwitch(e) {
      console.log("是否启用", e);
      this.xx_status = e;
    },
    // 新增/编辑小程序侧边栏-确认按钮
    xcxRequest() {
      let that = this;
      let xxx = 0;

      if (!that.x_gzh_account) {
        // 引导页所在公众号（需要关联小程序）
        that.$message.warning("引导页所在公众号不能为空");
      } else if (!that.x_name) {
        // 小程序名称
        that.$message.warning("小程序名称不能为空");
      } else if (!that.x_content_type) {
        // 小程序类型
        that.$message.warning("小程序类型不能为空");
      } else if (!that.x_app_origin_id) {
        // 小程序原始ID
        that.$message.warning("小程序原始ID不能为空");
      } else if (!that.x_app_id) {
        // 小程序APPID
        that.$message.warning("小程序APPID不能为空");
      } else if (!that.x_app_secret) {
        // 小程序密钥
        that.$message.warning("小程序密钥不能为空");
      } else if (!that.x_app_path) {
        // 跳转路径
        that.$message.warning("跳转路径不能为空");
      } else {
        that.xcx_add_edit_loading = true;
        if (that.xx_status) {
          xxx = 1; // 1表示启用
        }
        if (that.xcx_drawer_title == "新增") {
          xcxOperAddXcx({
            gzh_account: that.x_gzh_account, // 引导页所在公众号（需要关联小程序）
            name: that.x_name, // 小程序名称
            app_id: that.x_app_id, // 小程序APPID
            app_secret: that.x_app_secret, // 小程序密钥
            app_path: that.x_app_path, // 跳转路径
            jump_type: 1, // 跳转方式 that.x_jump_type
            status: xxx, // 是否启用
            content_type: that.x_content_type, // 小程序类型
            app_origin_id: that.x_app_origin_id, // 小程序原始ID
          }).then((res) => {
            that.xcx_add_edit_loading = false;
            console.log("新增确认按钮", res);
            if (
              res.data.code === 0 ||
              res.data.code === 200 ||
              res.data.code == 8011
            ) {
              that.xcxCloseDrawer();
              that.$message.success("操作成功");
              that.searchButton();
            } else {
              if (res.data.code === 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        } else if (that.xcx_drawer_title == "编辑") {
          xcxOperEditXcx({
            id: that.x_id, // id
            gzh_account: that.x_gzh_account, // 引导页所在公众号（需要关联小程序）
            name: that.x_name, // 小程序名称
            app_id: that.x_app_id, // 小程序APPID
            app_secret: that.x_app_secret, // 小程序密钥
            app_path: that.x_app_path, // 跳转路径
            jump_type: 1, // 跳转方式 that.x_jump_type
            status: xxx, // 是否启用
            content_type: that.x_content_type, // 小程序类型
            app_origin_id: that.x_app_origin_id, // 小程序原始ID
          }).then((res) => {
            that.xcx_add_edit_loading = false;
            console.log("编辑确认按钮", res);
            if (
              res.data.code === 0 ||
              res.data.code === 200 ||
              res.data.code == 8011
            ) {
              that.xcxCloseDrawer();
              that.$message.success("操作成功");
              that.searchButton();
            } else {
              if (res.data.code === 401) {
                // 未登录
                localStorage.removeItem("access_token");
                that.$router.replace({
                  name: "login",
                  params: { type: "not_log" },
                });
              } else {
                that.$message.error(`错误：${res.data.msg}`);
              }
            }
          });
        }
      }
    },
    // 小程序新增/编辑侧边栏关闭
    xcxCloseDrawer() {
      let that = this;
      if (this.xcx_add_edit_loading) {
        return;
      }
      this.xcx_visible = false;
      (this.x_gzh_account = ""), // 引导页所在公众号（需要关联小程序）
        (this.x_name = ""), // 小程序名称
        (this.x_app_id = ""), // 小程序APPID
        (this.x_app_secret = ""), // 小程序密钥
        (this.x_app_path = ""), // 跳转路径
        (this.x_jump_type = 1), // 跳转方式
        (this.xx_status = false); // 是否启用
    },

    editChangeA(e) {
      this.e_applets_id = e;
    },
  },
  filters: {
    wxTableStatus(value) {
      // console.log("过滤器",value)
      let vvv;
      if (value == 1) {
        vvv = "正常";
      } else if (value == 2) {
        vvv = "取消绑定";
      } else if (value == 3) {
        vvv = "删除";
      } else if (value == 4) {
        vvv = "已禁用";
      }
      return vvv;
    },
  },
};
</script>

<style scoped>
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 7px;
  margin-bottom: 3px;
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}

.class-title {
  width: 140px;
}

.set-xcx-box {
  position: relative;
  padding: 25px 10px 5px;
  margin-bottom: 25px;
  border-radius: 8px;
  background-color: #eff1f7;
}
</style>
